import dayjs from "dayjs";
import {
    CheckoutOrder,
    OrderType,
    PaymentForm,
    Point,
    Price,
    ProductOrderItem,
} from "tm-shared/types";
import { isPointDistribution } from "tm-shared/utils";

interface BuildOfflineCheckoutOrderProps {
    productsArr: ProductOrderItem[];
    currentPriceList: Record<string, Price>;
    point: Point;
    orderId: string;
    paymentForm: PaymentForm;
    orderType: OrderType;
}

export const buildOfflineCheckoutOrder = ({
    productsArr,
    currentPriceList,
    point,
    orderId,
    paymentForm,
    orderType,
}: BuildOfflineCheckoutOrderProps): CheckoutOrder => {
    const {
        id,
        name,
        market: { contragent, building },
    } = point;

    const client = isPointDistribution(point)
        ? point.typeContext.client
        : { id: "", name: "" };

    const products = productsArr.reduce(
        (acc, product) => {
            acc[product.barcode] = {
                ...product,
                price: currentPriceList?.[product.barcode]?.price ?? -1,
            };
            return acc;
        },
        {} as CheckoutOrder["products"],
    );

    return {
        pointId: id,
        marketId: point.market.id,
        marketName: name,
        partner: client.name,
        partnerId: client.id,
        address: building.address.name,
        contragent: contragent.name,
        orderId,
        orderType,
        products: products,
        paymentForm,
        shipmentDate: "",
        customShipmentDate: "",
        id: "",
        comments: [],
        isCarrier: false,
        isSelfDelivery: false,
        creationDate: dayjs().toISOString(),
        paymentDate: "",
        amount: 0,
        debt: 0,
        closed: false,
        isCredit: true,
        overdueDays: 0,
    };
};
